import { render, staticRenderFns } from "./InvPorProveedor.vue?vue&type=template&id=fc5888ec&"
import script from "./InvPorProveedor.vue?vue&type=script&lang=js&"
export * from "./InvPorProveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports